{/* Auto-generated icon - do not edit */}
import React from 'react'

interface SpoonIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const SpoonIcon = React.forwardRef<SVGSVGElement, SpoonIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 60 158"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M16.7847 106.886C16.7847 102.62 16.845 98.3539 16.7722 94.0909C16.6337 86.0121 16.5064 77.9299 16.154 69.8589C16.0923 68.4445 15.1695 66.91 14.269 65.7194C11.7598 62.4153 8.88721 59.3812 6.45156 56.0292C0.0752373 47.2612 -0.958531 37.7213 2.87054 27.6334C6.4233 18.2733 11.7651 10.2188 20.4741 4.90573C31.8143 -2.01207 43.9309 0.245763 51.9126 11.3379C59.408 21.7553 60.7831 33.3711 57.1594 45.6453C56.0847 49.6629 54.3368 53.4692 51.9901 56.9027C48.7845 61.3658 45.3894 65.6865 42.1819 70.1458C41.5754 71.0371 41.2428 72.0865 41.225 73.1649C41.1698 85.0637 41.544 96.9749 41.1147 108.857C40.7025 120.286 39.5513 131.691 38.5615 143.092C38.3035 145.546 37.7099 147.953 36.7973 150.246C34.7042 155.732 27.4451 158.384 22.1537 155.831C21.0819 155.321 20.1372 154.579 19.388 153.659C18.6387 152.739 18.1036 151.663 17.8218 150.51C17.0404 147.934 16.5818 145.271 16.4566 142.582C16.3135 130.684 16.3912 118.783 16.3912 106.883L16.7847 106.886ZM27.7377 149.17C29.7251 147.136 30.0876 146.538 30.3527 143.959C30.7669 139.943 31.2302 135.919 31.3411 131.889C31.6831 119.439 31.9625 106.986 32.0727 94.5327C32.1259 88.4753 31.6501 82.4153 31.593 76.3554C31.5313 69.8163 32.8514 63.6834 37.3966 58.5896C38.9619 56.8352 40.2343 54.8241 41.7281 53.0035C45.149 48.839 47.1436 44.0622 48.4136 38.8502C49.4253 34.9847 49.6186 30.9505 48.9809 27.006C48.343 23.0615 46.8885 19.2938 44.7101 15.9441C40.5096 9.2422 33.5836 7.16412 26.6179 10.3985C23.5388 11.801 20.8255 13.8962 18.6896 16.5203C14.6578 21.5155 11.9164 27.4257 10.7072 33.7301C10.1211 36.3656 10.0704 39.092 10.5584 41.7473C11.0466 44.4027 12.0635 46.9328 13.5485 49.1875C14.8722 51.2712 16.3061 53.2826 17.8442 55.2133C21.2703 59.4572 24.5729 63.7109 23.9192 69.6528C23.9246 69.7651 23.9468 69.8754 23.9849 69.981C25.7274 78.9072 26.6245 87.9778 26.6641 97.0727C26.8951 110.992 27.0579 124.913 27.2903 138.832C27.3428 142.069 27.5664 145.305 27.7377 149.17Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="59.0704" height="156.208" fill={color} transform="translate(0.591309 0.837891)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

SpoonIcon.displayName = 'SpoonIcon'
